import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { User } from "../domain/user";
import { UserService } from "../service/user.service";
import { MessageService } from "primeng/api";
import { Router } from "@angular/router";

@Component({
    templateUrl: "./usertable.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class UserTableComponent implements OnInit {
    cols: any[];

    users: User[];

    selectedUser: User;

    sortKey: string;

    sortField: string;

    sortOrder: number;

    timeout: any;
    isDisabled: boolean = false; 

    constructor(
        private UserService: UserService,
        private messageService: MessageService,
        private router: Router
    ) {}

    ngOnInit() {
        this.cols = [
            { field: "id", header: "ID" },
            { field: "Name", header: "Username / Login" },
            { field: "FirstName", header: "First name" },
            { field: "LastName", header: "Last name" },
        ];

        this.UserService.get().then((users) => (this.users = users));
    }

    viewUser(User: User) {
        this.router.navigate(["/users", User.id]);
    }

    deleteUser(User: User) {
        if (
            confirm(
                "Please confirm that you want to delete this user: " + User.Name
            )
        ) {
            this.isDisabled=true;
            this.UserService.delete(User.id)
            .then((l) =>
                this.UserService.get().then((users) => (this.users = users))
            )
            .then(data=>{
                this.isDisabled=false;
            })
            .catch(error => {
                this.isDisabled=false;
            }); 

           /* this.messageService.add({
                severity: "info",
                summary: "User deleted",
                detail: User.id + " - " + User.Name,
            });
            */
        }
    }

    createUser() {
        this.router.navigate(["/users", "new"]);
    }

    onSortChange(event) {
        const value = event.value;

        if (value.indexOf("!") === 0) {
            this.sortOrder = -1;
            this.sortField = value.substring(1, value.length);
        } else {
            this.sortOrder = 1;
            this.sortField = value;
        }
    }
}
